const initialState = {
    //get competitors groups
    competitorsGroupsFetching: false,
    competitorsGroupsFetched: false,
    addCompetitorsGroupsFetching: false,
    competitorsGroupsData: {},
    addCompetitorsGroupsData: {},
    competitorsGroupsError: null,
};

export default function reducer(state = initialState, action) {
    switch (action.type) {

        case "GET_COMPETITORS_GROUPS_PENDING": {
            state = Object.assign({}, state, { competitorsGroupsFetching: true });
            break;
        }
        case 'GET_COMPETITORS_GROUPS_FULFILLED': {
            state = Object.assign({}, state, { competitorsGroupsFetching: false,competitorsGroupsData: action.data });
            break;
        }
        case 'GET_COMPETITORS_GROUPS_REJECTED': {
            state = Object.assign({}, state, { competitorsGroupsError: action.error });
            break;
        }
        case 'ADD_COMPETITORS_GROUPS_PENDING': {
            state = Object.assign({}, state, { competitorsGroupsFetching: true ,addCompetitorsGroupsFetching: true});
            break;
        }
        case 'ADD_COMPETITORS_GROUPS_FULFILLED': {
            state = Object.assign({}, state, { competitorsGroupsFetching: false, addCompetitorsGroupsFetching: false, addCompetitorsGroupsData: action.data });
            break;
        }
        case 'ADD_COMPETITORS_GROUPS_REJECTED': {
            state = Object.assign({}, state, { competitorsGroupsError: action.error });
            break;
        }
        case 'EDIT_COMPETITORS_GROUPS_PENDING': {
            state = Object.assign({}, state, { competitorsGroupsFetching: true, addCompetitorsGroupsFetching: true});
            break;
          }
          case 'EDIT_COMPETITORS_GROUPS_FULFILLED': {
              state = Object.assign({}, state, { competitorsGroupsFetching: false,addCompetitorsGroupsFetching: false, addCompetitorsGroupsData: action.data });
              break;
          }
          case 'EDIT_COMPETITORS_GROUPS_REJECTED': {
            state = Object.assign({}, state, { competitorsGroupsError: action.error });
            break;
          }
    }
    return state;
}





// WEBPACK FOOTER //
// ./src/store/reducers/competitiveAnalysisReducer.js